import Vue from "vue";

const modulesFiles = require.context('./modules', true, /\.js$/)
modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    // modules[moduleName] = value.default
    Vue.filter(moduleName, value.default)
    return modules
}, {})

// console.log("modules", modules)

// const store = new Vuex.Store({
//     modules,
//     getters
// })

// export default store